module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/badges_png/reward_badge_aurora-8e833a641f68c2ddd9c395b35b5fdbac.png";